const NoGroupsAssigned = ({ a }: { a: string }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path
          d="M10.75 37.6197L10.8134 37.6835C7.37602 34.2453 5.25 29.4959 5.25 24.25C5.25 13.7566 13.7566 5.25 24.25 5.25C29.5298 5.25 34.3067 7.40359 37.75 10.8803L37.687 10.8169"
          stroke="#A2A8B0"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M4.25 44.25L44.25 4.25" stroke="#A2A8B0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M40.75 14.8228C42.3407 17.6009 43.25 20.8193 43.25 24.25C43.25 34.7434 34.7434 43.25 24.25 43.25C20.8193 43.25 17.6009 42.3407 14.8228 40.75"
          stroke="#A2A8B0"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div
        style={{
          display: "flex",
          gap: "12px",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            font: "600 20px Inter, sans-serif",
            color: "#696F77",
            textAlign: "center",
            letterSpacing: "-0.2px",
          }}
        >
          {a}
        </div>
        <div
          style={{
            font: "500 13px Inter, sans-serif",
            color: "#696F77",
            textAlign: "center",
            letterSpacing: "-0.13px",
            width: "465px",
          }}
        >
          You are not currently listed as an owner of any Active Directory groups. If you believe this is an error, please contact the support team.
        </div>
      </div>
    </div>
  );
};

export default NoGroupsAssigned;
